import { Button } from "@bracket/react-button";
import { useState } from "react";
import "./ErrorDisplay.scss";

interface ErrorDisplayProps {
  error: Error;
  onDismiss: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onDismiss,
}) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleCopyError = () => {
    const errorText = `Error message: ${error.message}\nStack trace: ${error.stack}`;
    navigator.clipboard.writeText(errorText).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    });
  };

  return (
    <div className="error-display-container">
      <div className="error-display-content">
        <h1 className="error-display-title">Oops! Something went wrong.</h1>
        <p className="error-display-message">{error.message}</p>
        <div className="error-display-buttons">
          <Button
            onClick={onDismiss}
            label="Dismiss"
            variant="outline"
            width="100%"
          />
          <Button
            onClick={handleRefresh}
            label="Refresh the page"
            variant="secondary"
            width="100%"
          />
          <Button
            onClick={handleCopyError}
            label={copySuccess ? "Copied!" : "Copy Error"}
            variant="primary"
            width="100%"
          />
        </div>
        {copySuccess && (
          <p className="error-display-copy-success">
            Error copied to clipboard!
          </p>
        )}
      </div>
    </div>
  );
};
